module.exports = __webpack_public_path__ + "static/media/Tamang Stoeies Plain Part 2 V1.06a771ba.mp4";